import { atomWithStorage } from "jotai/utils";

const STORAGE_KEY = "priorityos-onboarding";
const STORAGE_VERSION = 1;

interface OnboardingStore {
  version: number;
  dismissed: boolean;
}

export const onboardingAtom = atomWithStorage<OnboardingStore>(STORAGE_KEY, {
  version: STORAGE_VERSION,
  dismissed: false,
});
